import React, { useEffect, useState, useMemo } from "react";
import CustomBtn from "../../../../components/btn/CustomBtn";
import { Modal } from "antd";
import api from "../../../../api";
import { useToast } from "../../../../components/toast";
import CustomSelect from "../../../../components/select/CustomSelect";
import CustomDatePicker from "../../../../components/picker/CustomDatePicker";

const GiveBundle = ({ userId, list = [], trigger }) => {
  // --- state ---
  const [bundleId, setBundleId] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // yoga
  const [yogaTimes, setYogaTimes] = useState([]);
  const [yogaTime, setYogaTime] = useState(null);

  const toast = useToast();

  // сонгогдсон багц
  const selectedBundle = useMemo(
    () => list.find((b) => b.id === bundleId) || null,
    [bundleId, list],
  );

  const isYogaBundle = selectedBundle?.program === "YOGA";

  // bundleId өөрчлөгдөхөд YOGA бол цагуудыг татна
  useEffect(() => {
    setYogaTimes([]);
    setYogaTime(null);

    if (!bundleId) return;
    if (!isYogaBundle) return;

    const loadYogaTimes = async () => {
      try {
        const res = await api.get_yoga_times(bundleId);
        if (res.status === 200) {
          // console.log("res.data.data", res.data.data);
          setYogaTimes(res.data.data || []);
        }
      } catch (e) {
        console.log("yoga times error", e?.response?.data || e?.message);
      }
    };

    loadYogaTimes();
  }, [bundleId, isYogaBundle]);

  const onCancel = () => {
    setShowModal(false);
    setBundleId("");
    setStartDate(null);
    setYogaTimes([]);
    setYogaTime(null);
  };

  const handleSave = async () => {
    if (!bundleId || !startDate) {
      toast("Багц болон өдрөө сонгоно уу.", "warning");
      return;
    }

    // YOGA багц бол заавал цаг сонгосон байх
    if (isYogaBundle && !yogaTime) {
      toast("YOGA багцад цаг (HH:mm) заавал сонгоно уу.", "warning");
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        user_id: userId || "",
        starts_at: startDate?.toISOString() || "",
        yoga_time: isYogaBundle ? yogaTime : null,
      };

      const res = await api.give_bundle(bundleId, payload);
      // console.log("give_bundle --->", res);

      if (res.status === 200) {
        toast("Багц амжилттай өгөгдлөө", "success");
        onCancel();
        trigger?.();
      } else {
        toast(res?.data?.message || "Алдаа гарлаа", "error");
      }
    } catch (e) {
      // console.log("give_bundle error", e);
      toast(
        e?.response?.data?.message || e?.message || "Алдаа гарлаа",
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const canSave =
    !!bundleId && !!startDate && (!isYogaBundle || !!yogaTime) && !isLoading;

  // console.log("list --->", list);

  return (
    <>
      <CustomBtn title={"Багц өгөх"} onClick={() => setShowModal(true)} />

      <Modal
        open={showModal}
        width={420}
        title={"Багц өгөх"}
        onCancel={onCancel}
        footer={
          <div className="d-flex gap-2 justify-content-end">
            <CustomBtn type="secondary" title="Болих" onClick={onCancel} />
            <CustomBtn
              title={"Хадгалах"}
              onClick={handleSave}
              disabled={!canSave}
              loading={isLoading}
            />
          </div>
        }
      >
        <div className="d-flex flex-column gap-2">
          <CustomSelect
            allowClear
            showSearch
            required
            title="Багц сонгох"
            value={bundleId}
            onChange={setBundleId}
            placeholder="Багц сонгох"
            options={list.map((c) => ({
              value: c.id,
              label: `${c.name} (${c.program})`,
            }))}
            disabled={!(list?.length > 0)}
            fullWidth
          />

          <CustomDatePicker
            required
            title="Эхлэх өдөр"
            value={startDate}
            onChange={(v) => setStartDate(v)}
            fullWidth
          />

          {/* YOGA үед цаг сонгох */}
          {isYogaBundle && (
            <CustomSelect
              required
              title="YOGA цаг (HH:mm)"
              placeholder="Цаг сонгох"
              value={yogaTime}
              onChange={setYogaTime}
              options={yogaTimes.map((t) => ({
                value: t,
                label: t,
              }))}
              disabled={!yogaTimes.length}
              fullWidth
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default GiveBundle;
